import { Outlet } from 'react-router-dom'
import { Header } from './Header'

export function AppShell() {
  return (
    <div className="app-shell">
      <Header />
      <main className="app-main"><Outlet /></main>
    </div>
  )
}
